<div class="PageTitle">
    <h3 style="text-align:left; padding-left: 2%; font-family: Roboto,Arial,sans-serif,Nucleo; color: #004f86;">
        Parameter Entry</h3>
</div>
<hr>

<div class="row">
    <!-- this card holds the parameter entries for package template -->
    <div class="col-md-12">
        <mat-card>
            <mat-card-title>
                <div class="PageTitle">
                    <h4
                        style="text-align:left; padding-left: 2%; font-family: Roboto,Arial,sans-serif,Nucleo; color: #004f86;">
                        Package Template Parameters</h4>
                </div>
            </mat-card-title>



            <mat-card-content>

                <mat-tab-group mat-stretch-tabs (selectedTabChange)="toggleSubmitButton()">
                    <mat-tab>
                        <ng-template mat-tab-label><b>Fold Diameter</b></ng-template>
                        <br>
                        <div class="row">

                            <div class="col-md-6">
                                <mat-form-field appearance="outline" class="w-100" style="width: 400px;">
                                    <mat-label>Fold Diameter</mat-label>
                                    <input [formControl]="foldDiameterParameterControl" matInput
                                        placeholder="Fold Diameter" value="">
                                    <mat-error>Invalid Fold Diameter</mat-error>
                                </mat-form-field>
                            </div>

                            <!-- button row for imb search -->
                            <div class="button-row col" style="padding-top: 10px;">
                                <button class="mr-1" mat-flat-button color="primary"
                                    (click)="submitFoldDiameterButton()" [disabled]="foldDiameterSubmitDisable">Fold
                                    Diameter Submit</button>
                            </div>

                        </div>

                    </mat-tab>
                    <mat-tab>
                        <ng-template mat-tab-label><b>Form Size</b></ng-template>
                        <!-- form size inputs -->
                        <div class="row">
                            <br>
                            <div class="col-md-6">
                                <mat-form-field appearance="outline" class="w-100" style="width: 400px;">
                                    <mat-label>Form Size Description</mat-label>
                                    <input [formControl]="formSizeDescParameterControl" matInput placeholder="Form Size"
                                        value="">
                                    <mat-error>Invalid Form Size Description</mat-error>
                                </mat-form-field>
                            </div>

                        </div>

                        <div class="row">

                            <div class="col-md-6">
                                <mat-form-field appearance="outline" class="w-100" style="width: 400px;">
                                    <mat-label>Form Size Width</mat-label>
                                    <input [formControl]="formSizeWidthParameterControl" matInput
                                        placeholder="Form Size" value="">
                                    <mat-error>Invalid Form Size Width</mat-error>
                                </mat-form-field>
                            </div>

                        </div>

                        <div class="row">

                            <div class="col-md-6">
                                <mat-form-field appearance="outline" class="w-100" style="width: 400px;">
                                    <mat-label>Form Size Length</mat-label>
                                    <input [formControl]="formSizeLengthParameterControl" matInput
                                        placeholder="Form Size" value="">
                                    <mat-error>Invalid Form Size Length</mat-error>
                                </mat-form-field>
                            </div>

                            <!-- button row for imb search -->
                            <div class="button-row col" style="padding-top: 10px;">
                                <button class="mr-1" mat-flat-button color="primary" (click)="submitFormSizeButton()"
                                    [disabled]="formSizeSubmitDisable">Form Size Submit</button>
                            </div>

                        </div>

                    </mat-tab>

                </mat-tab-group>

            </mat-card-content>
        </mat-card>
    </div>

</div>